import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  transparentBg: {
    backgroundColor: 'transparent',
  },
}));
